import router from "./router";
import { isMobile } from "./utils/adaptive.js";
import { pcRoutes, mobileRoutes } from "./router";

// 判断当前设备的型号从而改变当前路由
const routes = isMobile() ? mobileRoutes : pcRoutes
console.log(isMobile(),routes);
routes.forEach(item => {
    router.addRoute(item)
});
